import Row from 'react-bootstrap/esm/Row'
import Col from 'react-bootstrap/esm/Col'
import styled from 'styled-components'
import { lazy, Suspense, useState } from 'react'
import { useAppSelector } from '../../store/store'

const SelectStudentModal = lazy(() => import('../SelectStudentModal/SelectStudentModal'))

export const StyledLogoCol = styled(Col)`
  display: flex;
  align-items: center;
`

export const StyledLogo = styled.img`
  max-height: 25px;
`

export const StyledUL = styled.ul`
  margin: 0 !important;

  li {
    display: inline-block;
    &.active {
      border-bottom: 7px solid #cf0101;
    }
    + li {
      margin-left: 10px;
    }
    a {
      font-weight: 700;
      color: #000 !important;
      padding: 0 10px;

      &:hover {
        color: #cf0101 !important;
        text-decoration: none;
      }
    }
  }
`

const Header = () => {
  const config = useAppSelector((store) => store.config)
  const [showModal, setShowModal] = useState<boolean>(false)

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    setShowModal(true)
  }

  return (
    <Row>
      <StyledLogoCol md={3}>
        {/* <StyledLogo
          src='/wp-content/uploads/2017/07/Wordmark-Variant-Dark.png'
          alt='Achieve Martial Arts'
          title='Achieve Martial Arts'
        /> */}
      </StyledLogoCol>
      <Col md={9} className='text-right'>
        <StyledUL className='top-right'>
          {config.is_instructor || config.is_admin ? (
            <li>
              <a href='#' onClick={handleClick}>
                {config.view_student?.studentName
                  ? `Viewing student [${config.view_student?.studentName}]`
                  : 'Select student'}
              </a>
            </li>
          ) : null}
          {/* <li className='active'>
            <a href='/challenge'>Dashboard</a>
          </li>
          <li>
            <a href='/leaderboard'>Leaderboard</a>
          </li> */}
        </StyledUL>

        <Suspense fallback=''>
          {showModal ? (
            <SelectStudentModal onClose={() => setShowModal(false)} selectedStudent={config.view_student} />
          ) : null}
        </Suspense>
      </Col>
    </Row>
  )
}

export default Header
